import { VisualisationContextProps } from 'widgets/supportVisualisation/Content/VisualisationContentProps';
import React from 'react';
import LabelValue from 'utils/components/LabelValue/LabelValue';
import './SupportVisualisationLocation.scss';
import {
    NotificationType,
    ToolbarIcon,
} from '@instinet-analytics/semantic-ui-components';
import useCopy from '@react-hook/copy';
import { useDispatchShowNotification } from 'notification/store/dispatcher';

export default function SupportVisualisationLocation(
    props: VisualisationContextProps
) {
    const { state, height, width } = props;
    const { location } = state!;

    const urlParams = new URLSearchParams(location.search);
    const loginKey = state!.globalVariables.key || urlParams.get('_k')!;
    const panelId = state!.globalVariables.panelId ?? urlParams.get('PanelId')!;

    const style = { height, width };

    const localEquiv = getLocalEquiv();

    const { copy } = useCopy(localEquiv);
    const showNotification = useDispatchShowNotification();

    const onClick = () => {
        copy().then(() => {
            showNotification('Copied to clipboard', NotificationType.Info);
        });
    };

    return (
        <div className={'SupportVisualisationLocation info'} style={style}>
            <LabelValue label="Url" value={location.href} />
            <LabelValue label="Hash" value={location.hash} />
            <LabelValue label="Key" value={loginKey} />
            <LabelValue label="Panel Id" value={panelId} />
            <div className={'LabelValue'}>
                <div className={'label'}>
                    Local Equivalent{' '}
                    <ToolbarIcon
                        name="clipboard outline"
                        active={true}
                        onClick={onClick}
                    />
                </div>
                <div className={'value'} title={localEquiv}>
                    <a
                        href={localEquiv}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {localEquiv} t
                    </a>
                </div>
            </div>
        </div>
    );

    function getLocalEquiv() {
        const pathName = location.pathname.replace('/Indigo2', '');
        return `http://localhost:3000${pathName}?_k=${loginKey}${location.hash}`;
    }
}
